export default __webpack_public_path__ + "static/media/banner-habibers.9fb5f079.png";